/* eslint-disable react/prefer-es6-class, one-var, react/jsx-no-bind */
import React from 'react';

export default React.createClass({
  displayName: 'Pagination',

  propTypes: {
    page: React.PropTypes.number,
    pages: React.PropTypes.number.isRequired,
    onPageClick: React.PropTypes.func.isRequired,
  },

  getDefaultProps() {
    return {
      page: 1,
    };
  },

  render() {
    if (this.props.pages <= 1) {
      return null;
    }

    let pages = [],
      previousPage = null,
      nextPage = null;

    for (let i = 1; i <= this.props.pages; i++) {
      if (i === this.props.page) {
        pages.push(<em key={i} className="current">{i}</em>);
      } else {
        pages.push(<a key={i} onClick={this.props.onPageClick.bind(null, i)}>{i}</a>);
      }
    }

    if (this.props.page === 1) {
      previousPage = <span className="previous_page disabled" />;
    } else {
      previousPage = <span className="previous_page" onClick={this.props.onPageClick.bind(null, this.props.page - 1)} />;
    }

    if (this.props.page === this.props.pages) {
      nextPage = <span className="next_page disabled" />;
    } else {
      nextPage = <span className="next_page" onClick={this.props.onPageClick.bind(null, this.props.page + 1)} />;
    }

    return (
      <div className="pagination">
        {previousPage}
        {pages}
        {nextPage}
      </div>
    );
  },
});
